import { useMemo } from 'react';

import EventInfoRow from './event-info-row';

type Props = {
  shares: string;
  totalCost: number;
};

const EventBuyProfitRow = ({ shares, totalCost }: Props) => {
  const profit = useMemo(() => {
    return (+shares - totalCost).toFixed(2);
  }, [shares, totalCost]);

  return (
    <EventInfoRow
      title="Profit"
      usdcClassName="size-[16px] md:size-[24px]"
      content={<p>+{profit}</p>}
      className="text-primary-cta text-[14px] font-medium md:text-[18px]"
    />
  );
};

export default EventBuyProfitRow;
